import { Component, Input } from '@angular/core';
import { FiltersComponent } from 'src/app/common/filters.component';

@Component({
	selector: 'app-settlement-term-filters',
	templateUrl: './settlement-term-filters.component.html',
	styleUrls: ['./settlement-term-filters.component.css'],
})
export class SettlementTermFiltersComponent extends FiltersComponent {
	@Input() drivers: Array<any>;
	@Input() settlementBonusNameIds: Array<any>;
	@Input() settlementKinds: Array<any>;
	@Input() users: Array<any>;
	@Input() isSettled: Array<any>;

	filters = {
		date_from: null,
		date_to: null,
		drivers: [],
		settlementBonusNameIds: [],
		settlementKind: [],
		user: [],
		isSettled: [],
	};
}
